<template>
    <div class="baner">
      <b-container>
        <b-row>
          <b-col cols="12" sm="6" md="6" lg="6" offset-lg="1" xl="6" offset-xl="1">
            <img v-if="language == 'ru'" src="../assets/main_ru.png">
            <img v-else src="../assets/main_en.png">
          </b-col>
          <b-col cols="12" sm="6" md="6" lg="5" xl="5">
            <b-row>
              <b-col class="txt1" sm="12" md="12" lg="12" xl="12">{{txt1[language]}}</b-col>
              <b-col class="txt2" sm="12" md="12" lg="12" xl="12">{{txt2[language]}}</b-col>
              <b-col class="txt3" sm="12" md="12" lg="12" xl="12">{{txt3[language]}}</b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
</template>

<script>
export default {
  name: 'AppBaner',
  props: {
    language: {
      type: String,
      default: 'ru'
    }
  },
  data() {
    return {
      txt1: {
        ru: 'Старт',
        en: 'Autocomponents'
      },
      txt2: {
        ru: 'автокомпонентов',
        en: 'start'
      },
      txt3: {
        ru: 'на рынке России',
        en: 'on the Russian market'
      },
    };
  }
}
</script>

<style lang="scss">
@media (min-width: 992px) and (max-width: 1199px) {
  .baner {
    height: 325px !important;
  }
  .baner img {
    margin-top: 45px !important;
  }
  .baner .txt1 {
    margin-top: 160px !important;
    font-size: 56px !important;
    line-height: 54px !important;
  }
  .baner .txt2 {
    font-size: 42px !important;
    line-height: 44px !important;
  }
  .baner .txt3 {
    font-size: 32px !important;
    line-height: 34px !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .baner {
    height: 270px !important;
  }
  .baner img {
    margin-top: 50px !important;
  }
  .baner .txt1 {
    margin-top: 120px !important;
    font-size: 50px !important;
    line-height: 50px !important;
  }
  .baner .txt2 {
    font-size: 38px !important;
    line-height: 40px !important;
  }
  .baner .txt3 {
    font-size: 28px !important;
    line-height: 30px !important;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .baner {
    height: 230px !important;
  }
  .baner img {
    margin-top: 55px !important;
  }
  .baner .txt1 {
    margin-top: 100px !important;
    font-size: 36px !important;
    line-height: 36px !important;
  }
  .baner .txt2 {
    font-size: 28px !important;
    line-height: 30px !important;
  }
  .baner .txt3 {
    font-size: 24px !important;
    line-height: 28px !important;
  }
}
@media (max-width: 575px) {
  .baner {
    height: auto !important;
  }
  .baner img {
    margin-top: 30px !important;
  }
  .baner .txt1 {
    margin-top: 0px !important;
    font-size: 44px !important;
    line-height: 48px !important;
  }
  .baner .txt2 {
    font-size: 36px !important;
    line-height: 38px !important;
  }
  .baner .txt3 {
    font-size: 28px !important;
    line-height: 30px !important;
    padding-bottom: 25px;
  }
}
.baner {
  height: 400px;
  background-size: cover;
  background-image: url("../assets/bg1.jpg");
  background-repeat: no-repeat;
  background-position: center center;
      letter-spacing: -0.65px; 
    font-family: 'Open Sans Condensed', sans-serif;
     font-weight: 700
}
.baner .txt1 {
  margin-top: 220px;
  color: #28a2dd;
  font-size: 58px;
  line-height: 64px;
  // font-family: "Libre Franklin", sans-serif;
}
.baner .txt2 {
  color: #28a2dd;
  font-size: 48px;
  line-height: 50px;
  // font-family: "Libre Franklin", sans-serif;
}
.baner .txt3 {
  color: #252525;
  font-size: 38px;
  line-height: 40px;
  // font-family: "Libre Franklin", sans-serif;
}
.baner img {
  margin-top: 70px;
  max-width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/Baner.vue